<div class="newProductContainer">
  <div class="floatRupture" *ngIf="product?.PHYSTO==0;">
    <div class="rupture">
      <i class="fa fa-exclamation-triangle"></i> En rupture de stock
    </div>
  </div>
   <a [routerLink]="['/product-details/',product.ITMREF]" class="ProductImgContainer" style="text-align: center;">
      <img onerror="this.onerror=null;this.src='assets/front/images/logo.png';" src="{{baseUrl}}/{{product.VIG}}"  class="img-fluid ProductImg"  loading="lazy" />
   </a>
   <div class="productData">
      <div class="productIcons text-center">
        <a  class="likeAction productActions" (click)="addToFavoris(product)">
          <span class="fa-stack fa-lg">
            <i class="fa fa-circle fa-stack-2x"></i>
            <i class="fa fa-heart fa-stack-1x fa-inverse"></i>
          </span>
        </a>
         <a [routerLink]="['/product-details/',product.ITMREF]" class="viewAction productActions">
         <span class="fa-stack fa-lg">
         <i class="fa fa-circle fa-stack-2x"></i>
         <i class="fa fa-eye fa-stack-1x fa-inverse"></i>
         </span>
         </a>
         <a  class="addtocartAction productActions" *ngIf="product?.PHYSTO!=0;" (click)="addToCard(product)" > <!--(click)="addToCard(product)"-->
           <div class="viewAction">
             <span class="fa-stack fa-lg">
               <i class="fa fa-circle fa-stack-2x"></i>
               <i class="fa fa-shopping-cart fa-eye fa-stack-1x fa-inverse"></i>
             </span>
           </div>
         </a>
      </div>
      <a [routerLink]="['/product-details/',product.ITMREF]" class="productDetails">
        <div class="productTitle text-center">
           {{product.ITMDES1}}
        </div>
        <!-- <div *ngIf="!typeCompte && promos == false" class="productPrice text-center">
          <strong>{{product.MONTANT}} </strong> MAD
       </div>
        <div *ngIf="typeCompte == 'B2C' && promos == false" class="productPrice text-center">
           <strong>{{product.MONTANT}} </strong> MAD
        </div>
        <div *ngIf="typeCompte == 'B2B' && promos == false" class="productPrice text-center">
          <strong>{{product.PRIXNET}} </strong> MAD
       </div>
       <div *ngIf="promos == 'true'" class="productPrice text-center">
          <span class="dashedPrice"><strong>{{product.PRIXBRUT}}</strong> MAD</span>
          <span class="promoPrice"><strong>{{product.MONTANT}}</strong> MAD</span>
          <sup class="pourcentagePromo">(-{{product.REMISE}}%)</sup>
      </div> -->

      </a>
   </div>
</div>
